import React, { useState } from 'react'
import Header from '../../components/header'
import Sidebar from '../../components/Sidebar'
import { useGetProfile } from '../../hooks/profile/profile'
import { useRecoilValue } from 'recoil'
import authAtom from '../../atoms/auth/auth.atom'
import SubscriptionModal from '../../components/SubscriptionModal'
import SubscriptionExpireModal from '../../components/SubscriptionExpireModal'
import { useGetPaymentMethods } from '../../hooks/business/business'
import { useGetSubscriptions } from '../../hooks/insuredCompany/insuredCompany'

const MainLayout = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [openSubModal, setOpenSubModal] = useState(false)
  const { isSubExpire } = useRecoilValue(authAtom)
  const onClose = () => setIsOpen(false)
  const onOpen = () => setIsOpen(true)
  useGetProfile()
  const { data: getData } = useGetSubscriptions(    
    { subscriptionType:'Insurance'},
    ["subscriptionType"],
  )

  const { data: payment } = useGetPaymentMethods()
  return (
    <div className='w-full h-screen flex bg-white'>
      <Sidebar isOpen={isOpen} onClose={onClose} />
      {/* open sub expire modal */}
      <SubscriptionExpireModal
        openModal={isSubExpire}
        openSubscriptionModal={setOpenSubModal}
      />
      {/* open subscription modal */}
      <SubscriptionModal
        openModal={openSubModal}
        closeModal={setOpenSubModal}
        subscriptions={getData?.data || []}
        paymentMethods={payment?.data || []}
      />
      <div id='main_layout' className='w-full md:w-[80%] lg:w-[82%] relative h-full overflow-y-auto'>
        <Header isOpen={isOpen} onOpen={onOpen} />
        <div className='pt-20'>
          {children}
        </div>
      </div>
    </div>
  )
}

export default MainLayout
